import { render } from "./AlignVerticalCenter.vue?vue&type=template&id=47ff3704"
import script from "./AlignVerticalCenter.vue?vue&type=script&lang=js"
export * from "./AlignVerticalCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlignVerticalCenter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47ff3704"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47ff3704', __exports__)) {
    api.reload('47ff3704', __exports__)
  }
  
  module.hot.accept("./AlignVerticalCenter.vue?vue&type=template&id=47ff3704", () => {
    api.rerender('47ff3704', render)
  })

}


export default __exports__